exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul[data-v-07e97909]{margin:0;padding:0;list-style-type:none}ul li[data-v-07e97909]{padding-top:.5rem;padding-bottom:.5rem}.sublist[data-v-07e97909]{margin-left:2rem;padding-left:1rem;list-style-type:circle}", ""]);

// exports
